import React, { useState, useEffect } from 'react';
import {
  Stack,
  TextField,
  Autocomplete,
} from "@mui/material";

interface Props { 
  values: string[];
  name: string;
  onChange: Function;
  disabled?: boolean;
}

export default function StringsBox({ 
  values,
  name, 
  onChange,
  disabled = false 
}: Props) {
  const [myValues, setValues] = useState(values);

  useEffect(() => {
    setValues(values);
  }, [values]);

  return (
    <Stack spacing={2}>
      <Autocomplete
        freeSolo
        disableClearable
        options={[]}
        multiple
        value={myValues}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={ name }
            InputProps={{
              ...params.InputProps,
              type: 'search',
            }}
          />
        )}
        onChange={(event: any, new_values: string[]) => {
          const new_strings = new_values.map(o => o.trim());
          onChange(new_strings);
          setValues(new_strings);
        }}
      />
    </Stack>
  );
}
